import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'not-found',
    useLayout: true,
    children: [{ id: SectionsKey.NotFound, order: 1 }]
};

export default PageStruct;
